import bigInt from 'big-integer';

export function decodeQRCode(qrcodeValue: string) {
  const qrcodeBigInt = bigInt(qrcodeValue);

  const cardNumber = qrcodeBigInt.and(0xffffffffff);
  return cardNumber.toString();
}
